import React from "react";
import { Grid, useTheme } from "@mui/material";
import { BuyNow, Heading, P } from "../../../Styles/style";
import tokenimage from "../../../../assets/images/ballon.png"
import { MainWrapper, MainGrid, Tokenimg, GridsWrap, GridsRead } from "./styles";

const Index = () => {
  const theme = useTheme()


  return (
    <MainWrapper p="10rem 0 2rem" id="mars" >
      <MainGrid container spacing={0}>
        <Grid item xs={12} md={9} >
        </Grid>
      </MainGrid>
      <Grid container spacing={0}>
        <GridsRead item xs={12} md={6} data-aos="fade-right" data-aos-easing="ease-in"
          data-aos-delay="400"
          data-aos-duration="500">
          <Tokenimg loading="lazy" src={tokenimage} />
        </GridsRead>
        <GridsWrap item xs={12} md={6} data-aos="fade-up"
          data-aos-anchor-placement="top-bottom" data-aos-delay="600"
          data-aos-duration="1000">
          <Heading ding align="LEFT" p="0px 0" data-aos="fade-left" data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="500">
            Join Mars<br />
            Mission
          </Heading>
          <P maxWidth="80%" p="0 0 20px">Floki, the legendary Norse dog sent from Valhalla, has embarked on a remarkable journey across blockchains in search of the perfect home for his people. After overcoming numerous challenges, his tireless quest leads him to the discovery of PulseChain, the ideal sanctuary. Pulsechain is not just a home, but a promising future for Floki and his community.  As they settle into their abode, they carry the legacy of their past and the limitless potential of their future.
          </P>
          <BuyNow href="https://app.pulsex.com/swap?outputCurrency=0x60C89f5eC551350235388b33d10643d46CaBE907" target="_blank" p="10px 30px" Color={theme.textSecondary} LineColor={theme.textSecondary} BgHoverTextColor={theme.textPrimary}
            BgHoverColors={theme.textSecondary} BgHoverColor={theme.BtnHover}><span /><span /><span /><span />
            Buy Now
          </BuyNow>
          <BuyNow href="https://www.dextools.io/app/en/pulse/pair-explorer/0x71267038ec334a963ab7987f6df4cf8441977fce" target="_blank" p="10px 30px" bgColor={theme.textSecondary}><span /><span /><span /><span />
            View Chart
          </BuyNow>
        </GridsWrap>
      </Grid>
    </MainWrapper>
  );
};

export default Index;
